import React from 'react'
import t from '../Language/language'
import { Config } from '../../Config'
import * as languageSettings from '../Language/languageSettings'
import AuthenticationService from '../Security/AuthenticationService'
import NavigationServices from '../Common/NavigationServices'

export default class SettingsHeader extends React.Component {
  constructor (props) {
    super(props)
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      token: this.authService.getToken()
    }
    this.state.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin())
    let path = window.location.pathname
    this.state.showSettings = path ? (path.indexOf('/settings') !== -1) : false
    this.navigation = new NavigationServices()
  }
  renderMenuItem (menu, display) {
    let active = (window.location.pathname ? (window.location.pathname.indexOf(menu) !== -1 ? 'active_tab_sub' : '') : '')
    return (<li>
      <a className={'headerMenu ' + active} href={this.navigation.getUrl(menu)} >{display}</a>
    </li>)
  }
  render () {
    const { language } = this.state
    if (!this.authService.isAdmin() && this.authService.isLoggedIn() && this.state.showSettings) {
      return (
        <div className='subMenu menuBar'>
          <ul className='subHeaders'>
            {this.renderMenuItem('stores', t[language].stores)}
            {this.renderMenuItem('users', t[language].users)}
            {this.renderMenuItem('roles', t[language].roles)}
          </ul>
        </div>
      )
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/SettingsHeader.js